
import Component from 'vue-class-component';
import {
  VtsCenterPracticeDetailsModel
} from "@/api-client";
import {Prop} from "vue-property-decorator";
import PracticePeriodsTable from "@/features/documents/practices/components/PracticePeriodsTable.vue";
import Files from "@/components/Files.vue";
import PracticeDetailsContentBase from "@/features/documents/practices/components/PracticeDetailsContentBase";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";

@Component({
  components: {
    HeadingGroup,
    PracticePeriodsTable,
    Files
  },
})
export default class PracticeVtsCenterDetailsContent extends PracticeDetailsContentBase {
  @Prop()
  details!: VtsCenterPracticeDetailsModel;
  @Prop()
  isOfficial?: boolean;
  
  get hasPracticePeriods(): boolean {
    return this.details.practicePeriods && this.details.practicePeriods.length > 0;
  }
  
  async getDownloadUrl(fileId: string): Promise<string> {
    // TODO: Use downloadVtsCenterFile when API client is regenerated
    return `/api/practices/vts-center/${this.details.id}/files/${fileId}`;
  }
}
